<template>
  <div class="total-transaction-pannel">
    <div id="tab-content">
      <div class="text-title">{{ $t('dashboard.today') }}
        <el-tooltip placement="bottom">
          <div slot="content">
            <span>{{ $t('tips.current_time_zone') }}</span>
          </div>
          <span><svg-icon icon-class="icon-font-warning" style="width: 22px;color: #0058CF;cursor: pointer;" /></span>
        </el-tooltip>
      </div>
      <el-row v-show="activeName === 'first' " :gutter="20" class="panel-group">
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_count') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.total_count || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_amount') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.total_amount | toDivideWithDot }}</div>
          </div>
        </el-col>

        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_fee') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.total_fee | toDivideWithDot }}</div>
          </div>
        </el-col>
      </el-row>
      <el-row v-show="activeName === 'second' " :gutter="20" class="panel-group">
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_count') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.payment_count || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_amount') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.payment_total_amount | toDivideWithDot }}</div>
          </div>
        </el-col>
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_fee') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.payment_fee | toDivideWithDot }}</div>
          </div>
        </el-col>
      </el-row>

      <el-row v-show="activeName === 'third' " :gutter="20" class="panel-group">
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_count') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.payout_count || 0 }}</div>
          </div>
        </el-col>
        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_amount') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.payout_total_amount | toDivideWithDot }}</div>
          </div>
        </el-col>

        <el-col :span="8" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-text">
              {{ $t('dashboard.transaction_fee') }}
            </div>
            <div class="card-panel-num color-main-linear-blue">{{ overviewData.payout_fee | toDivideWithDot }}</div>
          </div>
        </el-col>
      </el-row>

    </div>

    <div id="tab-container">
      <div class="tab-header" :class="{active: activeName === 'first'}" @click="activeName = 'first' ">{{ $t('dashboard.total_transaction') }}</div>
      <div class="tab-header" :class="{active: activeName === 'second'}" @click="activeName = 'second' ">{{ $t('dashboard.payin') }}</div>
      <div class="tab-header" :class="{active: activeName === 'third'}" @click="activeName = 'third' ">{{ $t('dashboard.payout') }}</div>
    </div>

  </div>

</template>

<script>
// import CountTo from 'vue-count-to'
import { fetchTodayTotalData } from '@/api/dashboard/dashboard.js'
export default {
  // components: {
  //   CountTo
  // },
  data() {
    return {
      overviewData: {
        payment_count: '0',
        payment_total_amount: '0',
        payout_count: '0',
        payout_total_amount: '0'
      },

      activeName: 'first'
    }
  },
  watch: {
    activeName: {
      handler(newValue, oldValue) {
        this.changeShowType(newValue)
      }
    }
  },
  created() {
    const { token } = this.$store.getters
    if (token) {
      this.getOverviewData()
    }
  },
  methods: {
    getOverviewData() {
      fetchTodayTotalData().then(res => {
        const {
          payment_count,
          payout_count,
          payment_total_amount,
          payout_total_amount,
          payout_fee,
          payment_fee
        } = res.data

        this.overviewData = {
          payment_count,
          payout_count,
          payout_fee,
          payment_total_amount,
          payout_total_amount,
          payment_fee,
          total_amount: +payment_total_amount + +payout_total_amount,
          total_count: +payment_count + +payout_count,
          total_fee: +payout_fee + +payment_fee
        }
      })
    },
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type)
    },
    changeShowType(type) {
      this.$emit('changeShowType', type)
    }
  }
}
</script>
<style lang="scss" scoped>
.text-title{
  color: #364250;
  font-size: 24px;
  font-weight: 600;
}
.total-transaction-pannel{
  padding: 24px;
  display: flex;
  margin-top: 24px;
  background: #FFF;
  border-radius: 8px;
}
.panel-group {
  padding-top: 10px;
  .card-panel-col{
    .card-panel {
      position: relative;
      box-sizing: border-box;
      margin-right: 16px;
      padding: 24px;
      border: 1.5px solid #D3D7DF;
      border-radius: 8px;
      overflow: hidden;
      .card-panel-text {
        font-weight: 500;  font-family: 'Poppins-Medium';
        font-size: 14px;
        line-height: 1.2;
        margin-bottom:16px;
        color: #364250;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .card-panel-num {
        font-weight: 600;
        font-family: 'Poppins-SemiBold';
        font-size: 24px;
        line-height: 1.2;
        word-wrap:break-word;
      }
    }
  }
}
#tab-content{
  flex: 1;
}
#tab-container{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 25%;
  .tab-header{
    padding: 12px;
    text-align: center;
    color: #364250;
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    border: 1px solid #D7D9DC;
    &.active{
      color: #0058CF;
      background: #DAE8FA;
      border: 1px solid #DAE8FA;
    }
  }
  .tab-header:hover{
    cursor: pointer;
  }
}
// @media screen and (max-width: 376px) {
//   .panel-group {
//     .card-panel-col {
//       width: 100%;
//     }
//   }
// }
</style>
